<template>
  <div class="financial-statement-item">
    <col-table :data="data" :pageSize="pageSize" :class="{ 'col-table--same': isSame, 'table-var': true }">
      <col-table-column label="日期" prop="endDate" :css="{ height: '50px' }">
        <template #header>
          <div class="date-header">
            <span>报告期<i class="iconfont icon-wenhao ml-4px" @click="popupVisible = true"></i></span>
            <span class="tongbi">
              {{ $t('同比')
              }}<span class="checkbox-wrap"><input type="checkbox" v-model="isSame" class="checkbox" /></span>
            </span>
          </div>
        </template>
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ scope.row.sortYear + scope.row.reportType }}</span>
            <span class="scale">{{ $t('同比') }}</span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="reportKind" label="报表种类">
        <template slot-scope="scope">{{
          $digitjs(reportKindMap[scope.row[formatAParams('reportKind')]]).isNull()
        }}</template>
      </col-table-column>
      <col-table-column prop="coverMonths" label="覆盖时期(月)">
        <template slot-scope="scope">{{ $digitjs(scope.row[formatAParams('coverMonths')]).isNull() }}</template>
      </col-table-column>
      <col-table-column prop="currency" label="报表货币" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">{{ $digitjs(scope.row[formatAParams('currency')]).isNull() }}</template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>资产</template>
      </col-table-column>
      <col-table-column prop="fixedAssets" label="固定资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('fixedAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('fixedAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('fixedAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="investments" label="投资">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('investments')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('investmentsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('investmentsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="goodwillIntangibleAssets" label="商誉及无形资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('goodwillIntangibleAssets')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('goodwillIntangibleAssetsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('goodwillIntangibleAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherNonCurrentAssets" label="其他非流动资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('otherNonCurrentAssets')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('otherNonCurrentAssetsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('otherNonCurrentAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalNonCurrentAssets" label="非流动资产总额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalNonCurrentAssets')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('totalNonCurrentAssetsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('totalNonCurrentAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="inventory" label="存货">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('inventory')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('inventoryYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('inventoryYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="tradeDebtors" label="贸易应收款项">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('tradeDebtors')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('tradeDebtorsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('tradeDebtorsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="cashAndNearCash" label="现金及银行结存">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('cashAndNearCash')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('cashAndNearCashYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('cashAndNearCashYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherCurrentAssets" label="其他流动资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('otherCurrentAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('otherCurrentAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('otherCurrentAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalCurrentAssets" label="流动资产总额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalCurrentAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('totalCurrentAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('totalCurrentAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netAssets" label="资产净值">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('netAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('netAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('netAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="fundsFromOperations" label="营运资金">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('fundsFromOperations')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('fundsFromOperationsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('fundsFromOperationsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="changesInWorkCapital" label="营运资金变动">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('changesInWorkCapital')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('changesInWorkCapitalYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('changesInWorkCapitalYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalCash" label="现金总额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalCash')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('totalCashYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('totalCashYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netCash" label="净现金/(债项)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('netCash')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('netCashYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('netCashYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalAssets" label="总资产" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('totalAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('totalAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>负债</template>
      </col-table-column>
      <col-table-column prop="tradeCreditors" label="贸易应付款项">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('tradeCreditors')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('tradeCreditorsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('tradeCreditorsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="shortTermDebt" label="短期债项">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('shortTermDebt')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('shortTermDebtYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('shortTermDebtYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherCurrentLiabilities" label="其他短期负债">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('otherCurrentLiabilities')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('otherCurrentLiabilitiesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('otherCurrentLiabilitiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalCurrentLiabilities" label="流动负债总额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalCurrentLiabilities')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('totalCurrentLiabilitiesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('totalCurrentLiabilitiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netCurrentAssets" label="流动资产/(负债)净值">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('netCurrentAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('netCurrentAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('netCurrentAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalAssetsLessCurrLiab" label="总资产减流动负债">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalAssetsLessCurrLiab')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('totalAssetsLessCurrLiabYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('totalAssetsLessCurrLiabYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="longTermDebt" label="长期债项">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('longTermDebt')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('longTermDebtYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('longTermDebtYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherNonCurrentLiab" label="其他非流动负债">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('otherNonCurrentLiab')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('otherNonCurrentLiabYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('otherNonCurrentLiabYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalNonCurrentLiab" label="非流动负债总额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalNonCurrentLiab')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('totalNonCurrentLiabYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('totalNonCurrentLiabYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalDebt" label="总债项">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalDebt')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('totalDebtYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('totalDebtYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="currentRatio" label="流动比率">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('currentRatio')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('currentRatioYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('currentRatioYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="quickAssets" label="速动资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('quickAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('quickAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('quickAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="debtAssetRatio" label="资产负债率">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('debtAssetRatio')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('debtAssetRatioYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('debtAssetRatioYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalLiabilities" label="总负债" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalLiabilities')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('totalLiabilitiesYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('totalLiabilitiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>股东权益</template>
      </col-table-column>
      <col-table-column prop="totalShareCapital" label="股本总额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalShareCapital')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('totalShareCapitalYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('totalShareCapitalYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalReserves" label="储备总额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalReserves')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('totalReservesYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('totalReservesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="ownersEquity" label="本公司拥有人应占权益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('ownersEquity')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('ownersEquityYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('ownersEquityYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="perpetualSecurities" label="永久资本证券">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('perpetualSecurities')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('perpetualSecuritiesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('perpetualSecuritiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="nonControllingInterests" label="非控股权益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('nonControllingInterests')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('nonControllingInterestsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('nonControllingInterestsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalEquity" label="权益总额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalEquity')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('totalEquityYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('totalEquityYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
    </col-table>
    <RkPopup :visible.sync="popupVisible"><ReportSheetPrompt /></RkPopup>
  </div>
</template>

<script>
import RkPopup from '@/components/common/Popup.vue'
import ReportSheetPrompt from '@/components/common/ReportSheetPrompt.vue'
export default {
  components: { RkPopup, ReportSheetPrompt },
  props: ['data', 'reportKindMap', 'css', 'mainDataStyle', 'formatAParams'],
  data() {
    return {
      isSame: false,
      popupVisible: false
    }
  },
  computed: {
    pageSize() {
      return this.isSame ? 1 : 2
    }
  }
}
</script>
